// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ehE0q3 {
  padding: var(--spacing-2) 0;
  border-bottom: 1px solid var(--bs-gray-200);
  transition: background-color 0.2s ease;
}

.ehE0q3:hover {
  background-color: var(--bs-gray-50);
}

.iK4_05 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.tZhvIB {
  flex: 1;
}

.qTIzXR {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  margin: 0;
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
}

.v5mXea {
  display: inline-flex;
  align-items: center;
}

.NKAzBk {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  margin: 0 0 var(--spacing-0-5) 0;
}

.Mm3sD6 {
  border-left: 1px solid var(--stroke-neutral-subtle);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  margin: 0 0 0 var(--spacing-1);
  padding-left: var(--spacing-1);
}

.ylUplQ {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  margin-top: var(--spacing-0-5);
}

.IKeuEa {
  width: 20px;
  height: 16px;
  flex-shrink: 0;
}

.tEuctH {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
}

.fhOgKT {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  color: var(--text-neutral-medium);
}

.OugiSd {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: #000000;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/BeneficiaryCard/BeneficiaryCard.module.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,2CAA2C;EAC3C,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,mDAAmD;EACnD,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,cAAc;AAChB","sourcesContent":[".beneficiaryItem {\n  padding: var(--spacing-2) 0;\n  border-bottom: 1px solid var(--bs-gray-200);\n  transition: background-color 0.2s ease;\n}\n\n.beneficiaryItem:hover {\n  background-color: var(--bs-gray-50);\n}\n\n.beneficiaryContent {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.beneficiaryMainInfo {\n  flex: 1;\n}\n\n.beneficiaryName {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n}\n\n.detailsTooltip {\n  display: inline-flex;\n  align-items: center;\n}\n\n.beneficiaryRole {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  margin: 0 0 var(--spacing-0-5) 0;\n}\n\n.beneficiaryId {\n  border-left: 1px solid var(--stroke-neutral-subtle);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  margin: 0 0 0 var(--spacing-1);\n  padding-left: var(--spacing-1);\n}\n\n.cardStatusRow {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  margin-top: var(--spacing-0-5);\n}\n\n.cardIcon {\n  width: 20px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.cardStatusText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n}\n\n.cardStatusTextNoIssued {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  color: var(--text-neutral-medium);\n}\n\n.beneficiaryValue {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: #000000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"beneficiaryItem": `ehE0q3`,
	"beneficiaryContent": `iK4_05`,
	"beneficiaryMainInfo": `tZhvIB`,
	"beneficiaryName": `qTIzXR`,
	"detailsTooltip": `v5mXea`,
	"beneficiaryRole": `NKAzBk`,
	"beneficiaryId": `Mm3sD6`,
	"cardStatusRow": `ylUplQ`,
	"cardIcon": `IKeuEa`,
	"cardStatusText": `tEuctH`,
	"cardStatusTextNoIssued": `fhOgKT`,
	"beneficiaryValue": `OugiSd`
};
module.exports = ___CSS_LOADER_EXPORT___;
